<div class="material-page">
  
  <div class="mdc-layout-grid">
    <div class="mdc-layout-grid__inner">
      <div class="left mdc-layout-grid__cell mdc-layout-grid__cell--span-7-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-4-phone">
        <div>
          <h1 class="mat-headline-3" i18n>Sign up to proceed.</h1>
          <h2 i18n>
            Our AI powered marketplace turns your unused things into cash completely effortlessly.
          </h2>
          <button 
              *ngIf="isLoggedIn"
              mat-raised-button
              (click)="toAccessInbox()"
              angulartics2On="click" 
              angularticsAction="Button Pressed"
              angularticsCategory="Continue"
              angularticsLabel="Continue"
              color="accent" 
              i18n="button label">Continue</button>
          <button 
              *ngIf="!isLoggedIn"
              mat-raised-button
              (click)="login()"
              angulartics2On="click" 
              angularticsAction="Button Pressed"
              angularticsCategory="Sign up"
              angularticsLabel="Sign up"
              color="accent" 
              i18n="button label">Sign up</button>
        </div>
      </div>
      
      <div class="right mdc-layout-grid__cell mdc-layout-grid__cell--span-5-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-4-phone">
        <div style="position: relative;">
          <img-with-placeholder [placeholder]="'/signup/signup_1_placeholder.webp' | assetUrl">
            <img style="max-width: 459px; width: 100%; height: auto" fullSizedImage ngSrc="/signup/signup_1.webp" ngSrcset="459w" height="459" width="459"/>
          </img-with-placeholder>
        </div>
      </div>
    </div>
    <div class="mdc-layout-grid__inner">
      
      <div class="left second-section-image-cell mdc-layout-grid__cell mdc-layout-grid__cell--span-5-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-4-phone">
        <div style="position: relative;">
          <img-with-placeholder [placeholder]="'/signup/signup_2_placeholder.webp' | assetUrl">
            <img style="max-width: 458px; width: 100%; height: auto" fullSizedImage ngSrc="/signup/signup_2.webp" ngSrcset="458w" height="458" width="458" loading="lazy"/>
          </img-with-placeholder>
        </div>
      </div>
      
      <div class="left mdc-layout-grid__cell mdc-layout-grid__cell--span-7-desktop mdc-layout-grid__cell--span-4-tablet mdc-layout-grid__cell--span-4-phone">
        <div>
          <h1 class="mat-headline-4" i18n>Sell with a few clicks. 0% fees.</h1>
          <h2 i18n>
            All your online purchases are automatically added to your Listx account. When you wish to resell an item, you can do it with just a few clicks.
          </h2>
        </div>
      </div>
    </div>
    <div class="mdc-layout-grid__inner">
      
      <div class="top mdc-layout-grid__cell--span-12">
        <div class="steps">
          <div class="step">
            <h1 class="mat-headline-1" style="margin:0px"><font class="with-stripe">1</font></h1>
            <h3 i18n>
              Sign up and allow our smart AI securely identify all online purchases from your Gmail inbox.
            </h3>
          </div>
          <div class="step">
            <h1 class="mat-headline-1" style="margin:0px"><font class="with-stripe">2</font></h1>
            <h3 i18n>
              Discover the items you no longer need and list them up for sale.
            </h3>
          </div>
          <div class="step">
            <h1 class="mat-headline-1" style="margin:0px"><font class="with-stripe">3</font></h1>
            <h3 i18n>Interested buyers will get in touch with you.</h3>
          </div>
        </div>
      </div>
      <div class="left mdc-layout-grid__cell bottom-signup">
        <div>
          <button 
              *ngIf="isLoggedIn"
              mat-raised-button
              (click)="toAccessInbox()"
              angulartics2On="click" 
              angularticsAction="Button Pressed"
              angularticsCategory="Continue"
              angularticsLabel="Continue"
              color="accent" 
              i18n="button label">Continue</button>
          <button 
              *ngIf="!isLoggedIn"
              mat-raised-button
              (click)="login()"
              angulartics2On="click" 
              angularticsAction="Button Pressed"
              angularticsCategory="Sign up"
              angularticsLabel="Sign up"
              color="accent" 
              i18n="button label">Sign up</button>
        </div>
      </div>
    </div>
  </div>
</div>